/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserSimpleDto } from './UserSimpleDto';
import {
    UserSimpleDtoFromJSON,
    UserSimpleDtoFromJSONTyped,
    UserSimpleDtoToJSON,
    UserSimpleDtoToJSONTyped,
} from './UserSimpleDto';

/**
 * 
 * @export
 * @interface ResponseListUserSimpleDto
 */
export interface ResponseListUserSimpleDto {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListUserSimpleDto
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListUserSimpleDto
     */
    message?: string;
    /**
     * 
     * @type {Array<UserSimpleDto>}
     * @memberof ResponseListUserSimpleDto
     */
    data?: Array<UserSimpleDto>;
}

/**
 * Check if a given object implements the ResponseListUserSimpleDto interface.
 */
export function instanceOfResponseListUserSimpleDto(value: object): value is ResponseListUserSimpleDto {
    return true;
}

export function ResponseListUserSimpleDtoFromJSON(json: any): ResponseListUserSimpleDto {
    return ResponseListUserSimpleDtoFromJSONTyped(json, false);
}

export function ResponseListUserSimpleDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListUserSimpleDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(UserSimpleDtoFromJSON)),
    };
}

export function ResponseListUserSimpleDtoToJSON(json: any): ResponseListUserSimpleDto {
    return ResponseListUserSimpleDtoToJSONTyped(json, false);
}

export function ResponseListUserSimpleDtoToJSONTyped(value?: ResponseListUserSimpleDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(UserSimpleDtoToJSON)),
    };
}

